import React from "react";
import DateFormatter from "./Formatter/DateFormatter";
import "./invoice.css"; // Importation du fichier CSS pour les styles
import logo from '../assets/logos/log.jpg'
import signature from '../assets/logos/signature.png'
const Invoice = React.forwardRef(({ choiceOrder }, ref) => {
  return (
    <div ref={ref} className="invoice-container">

      <div className="invoice-header">
      <img src={logo} alt="Company Logo" className="invoice-logo" />
        <h2 className="invoice-title">Invoice</h2>
        <p className="invoice-date">
          Date: <strong>{DateFormatter({date:choiceOrder.date})}</strong>
        </p>
      </div>

      <div className="invoice-details">
       
        <p><strong>Order ID:</strong> {choiceOrder.fullOrderId}</p>
        <p><strong>Place:</strong> {choiceOrder.place_name}</p>
        <p><strong>Item:</strong> {choiceOrder.braid_name}</p>
        <p><strong>Quantity:</strong> {choiceOrder.quantity}</p>
        <p>
          <strong>Total Price:</strong>{" "}
          <span className="invoice-price">
            {choiceOrder.pricePromo ? choiceOrder.pricePromo : choiceOrder.price} $
          </span>
        </p>
        <p><strong>Start Time:</strong> {choiceOrder.startTime}</p>
        <p><strong>End Time:</strong> {choiceOrder.endTime}</p>
      </div>

      <div className="invoice-footer">
        <p className="footer-note">
          Thank you for your order! We hope to serve you again soon.
        </p>
        <div className="invoice-signature">
          <p><strong>Authorized Signature:</strong></p>
          <img src={signature} alt="Electronic Signature" className="signature-img" />
        </div>
      </div>
    </div>
  );
});

export default Invoice;
